import { getResponseData } from '@/helpers/mocks';
import { HttpResponse, delay } from 'msw';

const RESPONSE = {
  default: {
    response: {
      createdAt: 1750744428956,
      error: {
        code: 0,
        label: '',
        message: '',
      },
      object: 'getbyborrowerage',
      success: true,
      data: [
        {
          _id: '67c582ae8a2a152b5321b202',
          title: 'investmentProperty',
          hebrew: 'דירה להשקעה',
          maxAge: null,
          maxFundingPercentage: 50,
          type: 'mortgage',
          description: 'רכישת נכס נוסף למטרת השקעה ולא למטרת מגורים',
          order: 4,
        },
        {
          _id: '67c48fdc78bf70f2582a1077',
          title: 'replacementProperty',
          hebrew: 'דירה חלופית',
          maxAge: null,
          maxFundingPercentage: 70,
          type: 'mortgage',
          description: 'באפשרותך להחליף את הנכס שברשותך בנכס חדש',
          order: 2,
        },
        {
          _id: '67c582ca8a2a152b5321b203',
          title: 'renovationOrExpansion',
          hebrew: 'שיפוץ או הרחבה',
          maxAge: null,
          maxFundingPercentage: 50,
          type: 'mortgage',
          description: 'לקיחת משכנתא לטובת שיפוץ או הרחבה של נכס קיים',
          order: 5,
        },
        {
          _id: '67c48f9878bf70f2582a1076',
          title: 'singleProperty',
          hebrew: 'דירה יחידה',
          maxAge: null,
          maxFundingPercentage: 75,
          type: 'mortgage',
          description: 'ברצונך לרכוש נכס ראשון ואין ברשותך נכס אחר',
          order: 1,
        },
        {
          _id: '67c5835a8a2a152b5321b204',
          title: 'anyPurposeWithPropertyCollateral',
          hebrew: 'כל מטרה במשכון נכס',
          maxAge: null,
          maxFundingPercentage: 75,
          type: 'general',
          description: 'לקיחת הלוואה לטובת כל מטרה שאינה עונה על אחת האפשרויות האחרות',
          order: 6,
        },
        {
          _id: '67cdc7c0720cd305383b29fe',
          title: 'mortgageRefinancing',
          hebrew: 'מחזור משכנתא',
          maxAge: null,
          maxFundingPercentage: 75,
          type: 'mortgage',
          description: 'בדוק מצבך במשכנתא הנוכחית ושפר תנאים',
          order: 3,
        },
        {
          _id: '67f0e119124e8f95788b0262',
          title: 'reverseMortgage',
          hebrew: 'משכנתא הפוכה',
          maxAge: null,
          maxFundingPercentage: 50,
          type: 'mortgage',
          description: 'משכנתא הפוכה לבני גיל 55 ומעלה',
          order: 7,
        },
      ],
    },
    error: {
      response: {
        createdAt: 1701115461239,
        object: 'login',
        success: false,
      },
      status: 500,
    },
  },
};

const loanOptionsHandler = async () => {
  const { response, status } = getResponseData(RESPONSE);
  await delay(1000);
  return HttpResponse.json(response, status);
};

export {
  loanOptionsHandler,
};
